document.addEventListener('DOMContentLoaded', function() {
  initQuickSizeEvents();
});

function initQuickSizeEvents() {
  document.querySelectorAll('.grid-item .quick-add__button:not(.event-bound)').forEach(container => {
    container.classList.add('event-bound');
    container.querySelector('.btn__text').addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
    });
    container.querySelectorAll('label').forEach(label => {
      label.addEventListener('click', event => {
        event.preventDefault();
        const input = label.previousElementSibling;
        if (!input || !input.value) return;

        const variantId = input.value;
        const form = label.closest('form');
        if (!form) return;

        const variantInput = form.querySelector('input[name="id"]');
        if (variantInput) {
          variantInput.value = variantId;
        }
        const quickAddBtn = form.querySelector('button.quick-add__button');
        if (quickAddBtn) {
          quickAddBtn.click();
        }
      });
    });
  });
}

document.addEventListener('theme:products:wim-updated', function() {
  initQuickSizeEvents();
});
document.addEventListener('theme:grid-slider:init', function() {
  setTimeout(() => {
    initQuickSizeEvents();
  }, 300);
});

document.querySelectorAll('.wim-collection-video').forEach(container => {
  const video = container.querySelector('video');
  if (!video) return;

  if (video.readyState >= 2) {
    container.classList.add('loaded');
  } else {
    video.addEventListener('loadeddata', () => {
      container.classList.add('loaded');
    });
  }
});
